import { NgModule } from '@angular/core';

import { PriceMatrixAddComponent }      from './price-matrix.add.component';
import { PriceMatrixAddGroupComponent } from './price-matrix.add-group.component';
import { PriceMatrixComponent }         from './price-matrix.settings.component';
import { PriceMatrixService }           from './price-matrix.service';
import { SharedModule }                 from '../shared/shared.module';
import { TableModule }                  from '../table/table.module';

@NgModule({
  declarations: [
    PriceMatrixAddComponent,
    PriceMatrixAddGroupComponent,
    PriceMatrixComponent
  ],
  entryComponents: [
    PriceMatrixAddComponent,
    PriceMatrixAddGroupComponent,
    PriceMatrixComponent
  ],
  imports: [
    SharedModule,
    TableModule
  ],
  providers: [
    PriceMatrixService
  ]
})
export class PriceMatrixModule {}
